import React, { ComponentType, ReactElement, ReactFragment, ReactNode } from 'react';
import { PropsOf } from 'ia-react-core/~/interfaces/PropsOf';

const filterChildrenByType = <
  Type extends ComponentType<{ children?: any } & any> & { type: Symbol }
>(children: ReactNode | Function, Component: Type) => {
  const result: ReactElement<PropsOf<Type>, Type>[] = [];

  if (children) {
    const { type } = Component;

    const resolvedChildren: string | ReactElement<PropsOf<Type>, Type> | ReactFragment = (
      children &&
      typeof children === 'object' &&
      'type' in children
      && children.type === React.Fragment
    ) ? children.props.children : children;

    React.Children.forEach(resolvedChildren, (child) => {
      const resolvedChild: ReactElement<PropsOf<Type>, Type> = (
        child &&
        typeof child === 'object' &&
        'type' in child &&
        child?.type === React.Fragment
      ) ? child.props.children : child;

      const childType = resolvedChild?.type?.type;

      if (childType === type) {
        result.push(resolvedChild);
      }
    });
  }

  return result;
};

/**
 * @visibleName filterChildrenByType
 * @component
 */
export default filterChildrenByType;
